import { createRequiredAndOptionalContext } from '../../libs/context'

type Props = {
  shouldBeVisible: boolean
  onChangeVisibility: (visible: boolean) => void
}
const [
  useShowChangesButtonContext,
  useOptionalShowChangesButtonContext,
  Provider,
] = createRequiredAndOptionalContext<Props>('ShowChangesButton')
export {
  Provider,
  useOptionalShowChangesButtonContext,
  useShowChangesButtonContext,
}
